import type { CSSProperties } from "react";

/**
 * A row that decides its own width.
 *
 * Either it states one outright, or it is centred with an auto margin — which
 * only means anything to a box narrower than the space it sits in, so a table
 * written that way is asking to shrink to its contents. The chip reading
 * "2-4 PM · 5-7 PM" is the shape: a bordered table with no width, `margin:0
 * auto`, and a single cell.
 *
 * Both renderers ask this. Keeping it in one place is what stops the canvas and
 * the inbox disagreeing about the same row — which is how the chip came to be a
 * chip in one and a rule across the whole email in the other.
 */
export function shrinksToFit(styles: CSSProperties): boolean {
  if (styles.width !== undefined) return true;
  // A capped row is not a shrinking one. "Fill what you are in, up to here,
  // and centre" is what a card does; a chip states no cap at all and wants to
  // be exactly as wide as its contents.
  if (styles.maxWidth !== undefined) return false;
  const margin = styles.margin;
  if (typeof margin === "string" && margin.includes("auto")) return true;
  return styles.marginLeft === "auto" && styles.marginRight === "auto";
}
